/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {ClrLoadingModule} from '../../utils/loading/loading.module';

import {LOADING_BUTTON_DIRECTIVES} from './index';
export class ClrLoadingButtonModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, ClrLoadingModule],
    declarations: [LOADING_BUTTON_DIRECTIVES],
    exports: [LOADING_BUTTON_DIRECTIVES, ClrLoadingModule]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrLoadingButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrLoadingButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrLoadingButtonModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
